/* Footer newsletter: submit in the background and keep the success message on screen.
   A normal submit reloads the page, and when Shopify's bot screening steps in it detours
   through /challenge, which reloads again and loses the message. If the background
   request lands on /challenge we fall back to a normal submit so the shopper can pass it,
   and remember to show the message when they're sent back. */

(function () {
  var PENDING_KEY = 'cf-newsletter-pending';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function setup(form) {
    if (form.dataset.cfBound) return;
    form.dataset.cfBound = 'true';

    var input = form.querySelector('input[name="contact[email]"]');
    var button = form.querySelector('button[type="submit"]');
    var message = form.querySelector('[data-cf-message]');
    var successTpl = form.querySelector('template[data-cf-success]');
    var successText = successTpl ? successTpl.innerHTML.trim() : 'Thanks for subscribing!';

    function show(text, kind) {
      if (!message) return;
      message.textContent = text;
      message.className = 'cf__form-message cf__form-message--' + kind;
      message.setAttribute('role', kind === 'error' ? 'alert' : 'status');
      message.hidden = false;
    }

    function succeed() {
      try { sessionStorage.removeItem(PENDING_KEY); } catch (e) {}
      show(successText, 'success');
      form.classList.add('cf__form--done');
      if (input) input.value = '';
    }

    var pending = false;
    try { pending = sessionStorage.getItem(PENDING_KEY) === '1'; } catch (e) {}
    var cameFromChallenge = /\/challenge/.test(document.referrer || '');
    var postedParam = /[?&]customer_posted=true/.test(location.search);
    if (pending && (postedParam || cameFromChallenge)) succeed();

    /* Hand the form back to Shopify's own submit flow (it handles bot verification and
       restores the form afterwards); its handler skips forms marked data-nocaptcha. */
    function nativeSubmit() {
      try { sessionStorage.setItem(PENDING_KEY, '1'); } catch (e) {}
      form.dataset.cfNative = 'true';
      form.removeAttribute('data-nocaptcha');
      button.disabled = false;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(button);
      } else {
        HTMLFormElement.prototype.submit.call(form);
      }
    }

    form.addEventListener('submit', function (event) {
      if (form.dataset.cfNative) return;
      event.preventDefault();

      var email = input ? input.value.trim() : '';
      if (!EMAIL_RE.test(email)) {
        show('Please enter a valid email address.', 'error');
        if (input) input.focus();
        return;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      })
        .then(function (res) {
          if (/\/challenge/.test(res.url)) {
            nativeSubmit();
            return null;
          }
          if (/[?&]customer_posted=true/.test(res.url)) {
            succeed();
            return null;
          }
          return res.text();
        })
        .then(function (html) {
          if (html == null) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var err = doc.querySelector('.cf__form-message--error');
          if (err) {
            show(err.textContent.trim(), 'error');
          } else {
            nativeSubmit();
          }
        })
        .catch(nativeSubmit)
        .finally(function () {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        });
    });
  }

  function init() {
    document.querySelectorAll('form[data-cf-newsletter]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
